import axios from 'axios';

import { HOST_API } from 'src/config-global';

export const getJwtToken = async (token: string) => {
  try {
    // Use a plain axios instance (no Authorization header) — this is a public
    // token-exchange endpoint. Using axiosInstance would send the stale Strapi
    // JWT and cause a 403 when the token has expired.
    const res = await axios.get(`${HOST_API}/api/auth/auth0/callback?access_token=${token}`);
    return res.data;
  } catch (error) {
    console.error(`Could not get token with error ${JSON.stringify(error, null, 2)} `);
    throw new Error('meh');
  }
};
